import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        display: false,
        message: "",
        type: "default",
        timeout: 5000,
    }),
    actions: {
        send(message, type = "default", timeout = 5000) {
            this.message = message;
            this.display = true;
            this.type = type;
            this.timeout = timeout;

        },

    },
    getters: {

    },
});